import client from './client';

/** Issues a login OTP for an existing policyholder, resolved by surname + vehicle registration. */
export async function sendLoginOtp(surname, regNo) {
  const response = await client.post('/api/care-portal/auth/login', {
    surname,
    regNo,
  });

  return { sent: response.data.sent, code: response.data.code };
}

/**
 * Redeems a login OTP and establishes a session. Surname/regNo bind the attempt to the identity
 * the code was issued for — the backend rejects a code/identity mismatch rather than looking a
 * code up on its own.
 */
export async function verifyLoginOtp(surname, regNo, code) {
  const response = await client.post('/api/care-portal/auth/verify', {
    surname,
    regNo,
    code,
  });

  return { token: response.data.token, expiration: response.data.expiration };
}
